export const environment = {
    baseUrl: localStorage.getItem('switchLocal') ? 'http://localhost:5000/api/' : 'https://api.tonezone.health/api/',
    production: false,
    accessKeyAws: 'AKIAYVREBNGIADT7AAHB',
    secretKeyAws: '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',
    bucketAws: 'tonezone-data-dev',
    stripeKey: 'pk_test_51PTdxWFG5Ha8xaN19L6zXZdPCyq6yjwQYM97mrePi27S1YG8Ftw8yORBpC69nkKU6Xh7lBEoOu7UUT8LkzUB2Cq200sD7fwdDx',
  };